<template>

    <b-container>
        <b-col>
            
            <b-row class="m-0">
                <span class="info-view-label"> Tma Id: </span> 
                <span class="info-item"> 
                    {{ tma.TmaDaxId }} 
                </span>
            </b-row>
            <hr class="my-4"/>

            <b-row class="m-0">
                <span class="info-view-label"> Название: </span> 
                <span class="info-item"> 
                    {{ tma.Name }} 
                </span>
            </b-row>
            <hr class="my-4"/>

            <b-row class="m-0">
                <span class="info-view-label"> Механика: </span> 
                <span class="info-item"> 
                    {{ tma.Mechanic }} 
                </span>
            </b-row>
            <hr class="my-4"/>

            <b-row class="m-0">
                <span class="info-view-label"> Скидка: </span> 
                <span class="info-item"> 
                    {{ tma.Discount }}%
                </span>
            </b-row>
            <hr class="my-4"/>

            <b-row class="m-0">
                <span class="info-view-label"> Дата начала: </span> 
                <span class="info-item"> 
                    {{ getDateToDisplay(tma.StartDate) }} 
                </span>
            </b-row>
            <hr class="my-4"/>

            <b-row class="m-0">
                <span class="info-view-label"> Дата окончания: </span> 
                <span class="info-item"> 
                    {{ getDateToDisplay(tma.EndDate) }} 
                </span>
            </b-row>
            <hr class="my-4"/>

            <b-row class="m-0">
                <span class="info-view-label"> ДМП: </span> 
                <span class="info-item"> 
                    {{ tma.Dmp }} 
                </span>
            </b-row>
            <hr class="my-4"/>

            <b-row class="m-0">
                <span class="info-view-label"> Каталог: </span> 
                <span class="info-item"> 
                    {{ tma.Catalog }} 
                </span>
            </b-row>

            <aep-view v-if="tma.Aeps.length" class="mt-20" :aep-model-list="tma.Aeps" />

        </b-col>
    </b-container>

</template>

<script>
import AepView from '@/components/client/tradePoints/view/AepView'
export default {
    props: {
        tma: {
            type: Object
        }        
    },
    data: function() {
        return {
            
        }
    },
    methods: {
        getDateToDisplay: function(value) {
            let dateToDisplay = new Date(value);
            dateToDisplay = `${dateToDisplay.getDate()}.${dateToDisplay.getMonth()+1}.${dateToDisplay.getFullYear()} ${dateToDisplay.getHours()}:${dateToDisplay.getMinutes()}:${dateToDisplay.getSeconds()}`;
            return dateToDisplay;
        }
    },
    components: {
        AepView
    }
}
</script>